import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable()
export class SignUpProvider {
  ISM_URL = environment.ismUrl
  DRS_URL = environment.drsServerUrl



  constructor(public http: HttpClient) {
    console.log('Hello SignUpProvider Provider');
  }


  uploadDocs(data,token) {
    return this.http.post<any>(`${this.DRS_URL}publicupload?api-token=${token}`, data, {

    })
      .toPromise();
  }

  generateOtp(data) {
    return this.http.post<any>(`${this.ISM_URL}/generateotp`, data, {

    })
      .toPromise();
  }
  resendOtp(data) {
    return this.http.post<any>(`${this.ISM_URL}/resendotp`, data, {

    })
      .toPromise();
  }

  verifyOtp(data) {
    return this.http.post<any>(`${this.ISM_URL}/validateotp`, data, {

    })
      .toPromise();
  }


  searchSociety(data) {
    return this.http.get<any>(`${this.ISM_URL}/searchsociety?key=${data.search}&token=${data.token}`, {
    })
      .toPromise();
  }


  getSocietyFrom(data) {
    return this.http.get<any>(`${this.ISM_URL}/form?form_type=${data.formtype}&token=${data.token}&society_id=${data.itemid}`, {
    })
      .toPromise();
  }

  getUnitNo(token,societyId) {
    return this.http.get<any>(`${this.ISM_URL}/societyassets?token=${token}&society_id=${societyId}`, {
    })
      .toPromise();
  }

  submitFromData(data) {
    return this.http.post<any>(`${this.ISM_URL}/submitform?token=${data.token}`, {
      "society_id": data.societyId,
      "form_data": data.formData
    }, {

    })
      .toPromise();
  }


  resubmitFromData(data) {
    return this.http.post<any>(`${this.ISM_URL}/resubmitform?token=${data.token}`, {
      "society_id": data.societyId,
      "form_data": data.formData,
      "form_id" : data.id,
    }, {

    })
      .toPromise();
  }

  requestStatus(societyId, formId, token) {
    return this.http.get<any>(`${this.ISM_URL}/getformstatus?token=${token}&society_id=${societyId}&form_id=${formId}`, {})
      .toPromise();
  }
  requestStatusViaLocalStorage() {
    var form = JSON.parse(localStorage.getItem('signup_data'));
		var token = localStorage.getItem('signup_token');
		var society = JSON.parse(localStorage.getItem('signup_society'));
		console.log([form,society,token]);
		return this.requestStatus(society.id, form.id,token)
  }
  getRegisterPhoneUnit(societyId, unitNo, phoneNo){
    var token = localStorage.getItem('signup_token');
    return this.http.get<any>(`${this.ISM_URL}/registerphoneunit?token=${token}&society_id=${societyId}&phone_no=${phoneNo}&unit_no=${unitNo}`, {})
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/providers/sign-up/sign-up.ts